function SiteFooter() {
    return (
        <footer
            className="mt-12 border-b-4 border-[#edf108] text-slate-100"
            style={{
                backgroundImage: "linear-gradient(rgba(0, 32, 44, 0.88), rgba(0, 75, 101, 0.84)), url('/footerbg.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                fontFamily: "'Open Sans', Arial, sans-serif",
            }}
        >
            <div className="mx-auto grid w-full max-w-[1700px] grid-cols-1 gap-12 px-4 py-16 md:grid-cols-3 md:items-start">
                <section className="max-w-[680px]">
                    <h3
                        className="mb-5 text-[16px] font-semibold leading-[27px] text-white"
                        style={{ fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif" }}
                    >
                        Glas Lilienthal - Glaserei & Glasbau:
                    </h3>
                    <p className="text-[15px] font-medium leading-[27px] text-slate-100/95">
                        Als Glaserei Meisterbetrieb sind wir Ihr erster Ansprechpartner fur zuverlassige und
                        professionelle Glasarbeiten in Bremen und Umgebung.
                    </p>
                    <div className="mt-8 flex flex-wrap gap-x-3 gap-y-2 text-[15px] font-medium leading-[27px] text-[#ffed00]">
                        <a href="https://glas-lilienthal.de/impressum/" target="_blank" rel="noreferrer" className="hover:text-yellow-300">
                            Impressum
                        </a>
                        <span>|</span>
                        <a href="https://glas-lilienthal.de/datenschutz/" target="_blank" rel="noreferrer" className="hover:text-yellow-300">
                            Datenschutz
                        </a>
                        <span>|</span>
                        <a href="https://glas-lilienthal.de/sitemap_index.xml" target="_blank" rel="noreferrer" className="hover:text-yellow-300">
                            Sitemap
                        </a>
                    </div>
                </section>

                <section className="md:pl-10">
                    <h3
                        className="mb-5 text-[16px] font-semibold leading-[27px] text-white"
                        style={{ fontFamily: "Poppins, Helvetica, Arial, Lucida, sans-serif" }}
                    >
                        Kontaktinfos:
                    </h3>
                    <p className="text-[15px] font-medium leading-[27px] text-slate-100/95">
                        Hauptstr. 53, 28865 Lilienthal
                        <br />
                        Tel. 04298-6994696
                        <br />
                        E-Mail: info@glas-lilienthal.de
                    </p>
                </section>

                <section className="flex justify-start md:justify-end md:pr-8">
                    <img
                        src="/logo.png"
                        alt="Glas Lilienthal"
                        className="h-auto w-full max-w-[520px] grayscale brightness-0 invert md:max-w-[430px]"
                        loading="lazy"
                    />
                </section>
            </div>

            <div className="bg-transparent">
                <div className="mx-auto w-full max-w-[1700px] px-4 pb-6">
                    <p className="text-[14px] font-medium text-slate-100/85">© Glas Lilienthal - Glaserei & Glasbau - Alle Rechte vorbehalten.</p>
                </div>
            </div>
        </footer>
    );
}

export default SiteFooter;
